// src/components/TileBuilder/ChartControls/ChartValueScaleControls.tsx
import React from 'react';
import { Box, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Switch, TextField, Typography } from '@mui/material';
import { setSettings } from '../../../../support/slices/tileBuilderSlice';
import { ChartControlProps } from './ChartControlProps';

const ChartValueScaleControls: React.FC<ChartControlProps> = ({ chartId, settings, dispatch }) => {
  const s: any = settings as any;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
      <Typography variant="subtitle2" sx={{ width: '100%' }}>
        Value Scale (Y for vertical, X for horizontal)
      </Typography>

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel>Scale Type</InputLabel>
        <Select
          label="Scale Type"
          value={s.valueScaleType ?? 'linear'}
          onChange={(e) => dispatch(setSettings({ chartId, settings: { valueScaleType: e.target.value as any } }))}
        >
          <MenuItem value="linear">Linear</MenuItem>
          <MenuItem value="symlog">SymLog (handles negatives better)</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Min"
        size="small"
        type="number"
        value={s.valueScaleMin ?? ''}
        onChange={(e) =>
          dispatch(setSettings({ chartId, settings: { valueScaleMin: e.target.value === '' ? '' : Number(e.target.value) } as any }))
        }
        sx={{ width: 140 }}
      />

      <TextField
        label="Max"
        size="small"
        type="number"
        value={s.valueScaleMax ?? ''}
        onChange={(e) =>
          dispatch(setSettings({ chartId, settings: { valueScaleMax: e.target.value === '' ? '' : Number(e.target.value) } as any }))
        }
        sx={{ width: 140 }}
      />

      <FormControlLabel
        control={
          <Switch
            checked={s.valueScaleNice !== false}
            onChange={(e) => dispatch(setSettings({ chartId, settings: { valueScaleNice: e.target.checked } as any }))}
          />
        }
        label="Nice"
      />

      <FormControlLabel
        control={
          <Switch
            checked={!!s.valueScaleRound}
            onChange={(e) => dispatch(setSettings({ chartId, settings: { valueScaleRound: e.target.checked } as any }))}
          />
        }
        label="Round"
      />

      {s.valueScaleType === 'symlog' && (
        <TextField
          label="Symlog Constant"
          size="small"
          type="number"
          value={s.valueScaleSymlogConstant ?? 1}
          onChange={(e) =>
            dispatch(setSettings({ chartId, settings: { valueScaleSymlogConstant: Number(e.target.value) } as any }))
          }
          sx={{ width: 180 }}
        />
      )}
    </Box>
  );
};

export default ChartValueScaleControls;